import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ standalone: false,
  name: 'mxDateAgo',
  pure: true,
})
export class MxDateAgoPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value) {
      const seconds = Math.floor(
        (+new Date() -
          +moment(
            moment(value).format('YYYY-MM-DD HH:mm:ss'),
            'YYYY-MM-DD HH:mm:ss',
            true
          ).toDate()) /
          1000
      );
      if (seconds < 29) return 'Épp most';
      const intervals: any = {
        éve: 31536000,
        hónapja: 2592000,
        hete: 604800,
        napja: 86400,
        órája: 3600,
        perce: 60,
        másodperce: 1,
      };
      let counter;
      for (const i in intervals) {
        counter = Math.floor(seconds / intervals[i]);
        if (counter > 0) return counter + ' ' + i;
      }
    }
    return value;
  }
}
